// extracted by mini-css-extract-plugin
export default {"formActions":"Z44man"};